<template>
  <b-card title="مدیریت کالری های جایگزین فستینگ">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search d-flex justify-content-end">
          <b-button
              variant="primary"
              @click="showFormModal = true"
          >
            جدید
          </b-button>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updatediet', params: { id: data.value }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(actions)="data">
            <div class="text-nowrap">
              <feather-icon
                  icon="EditIcon"
                  size="16"
                  @click="edit(data.item)"
              />
              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>

    <b-modal
        v-model="showFormModal"
        v-if="showFormModal"
        centered
        hide-footer
        :title="form.id ? 'ویرایش کالری جایگزین' : 'افزودن کالری جایگزین جدبد'"
        :no-close-on-backdrop="true"
        size="sm"
    >
      <b-row>
        <b-col md="6">
          <b-form-group
              :label="$t('foods.fromCalorie')"
              label-for="StartCalorie"
          >
            <cleave
                id="StartCalorie"
                v-model="form.StartCalorie"
                class="form-control"
                :raw="false"
                :options="options"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
              :label="$t('foods.toCalorie')"
              label-for="EndCalorie"
          >
            <cleave
                id="EndCalorie"
                v-model="form.EndCalorie"
                class="form-control"
                :raw="false"
                :options="options"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
              :label="$t('foods.alternativeCalorie')"
              label-for="AlternateCalorie"
          >
            <cleave
                id="AlternateCalorie"
                v-model="form.AlternateCalorie"
                class="form-control"
                :raw="false"
                :options="options"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div class="text-center mt-2">
        <b-overlay :show="formLoading" rounded spinner-small class="d-inline-block">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
              :disabled="formLoading"
              @click="save"
          >
            ذخیره
          </b-button>
        </b-overlay>
        <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="showFormModal = false"
        >
          انصراف
        </b-button>
      </div>
    </b-modal>
  </b-card>
</template>

<script>

export default {
  name: 'AlternativeCalories',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      formLoading: false,
      showFormModal: false,
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
      filterOptions: {
        Page: 1,
      },
      form: {
        StartCalorie: '',
        EndCalorie: '',
        AlternateCalorie: '',
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'StartCalorie',
          label: this.$t('foods.fromCalorie'),
        },
        {
          key: 'EndCalorie',
          label: this.$t('foods.toCalorie'),
        },
        {
          key: 'AlternateCalorie',
          label: this.$t('foods.alternativeCalorie'),
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  watch: {
    showFormModal(val) {
      if (!val) this.form = {}
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.get(
        this.$api.alternativeCalorie.getlist, { params: this.filterOptions }
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      if (!this.form.StartCalorie || !this.form.EndCalorie || !this.form.AlternateCalorie) return

      this.formLoading = true

      let data = {
        ...this.form,
        StartCalorie: this.form.StartCalorie.replaceAll(',', ''),
        EndCalorie: this.form.EndCalorie.replaceAll(',', ''),
        AlternateCalorie: this.form.AlternateCalorie.replaceAll(',', '')
      }

      let url = this.form.id ? this.$api.alternativeCalorie.update : this.$api.alternativeCalorie.add

      this.$http.post(url, data).then(() => {
        this.formLoading = false
        this.showFormModal = false
        this.form = {}
        this.update()
      }).finally(() => {
        this.formLoading = false
      })
    },
    edit(item) {
      this.form.id = item.Id
      this.form.StartCalorie = item.StartCalorie
      this.form.EndCalorie = item.EndCalorie
      this.form.AlternateCalorie = item.AlternateCalorie

      this.showFormModal = true
    },
    remove(id) {
      this.removeRow(this.$api.alternativeCalorie.remove, 'id', id)
    }
  },
}
</script>
